module.exports = __webpack_public_path__ + "5c114213/img/scraper-icon.df6ccde5.svg";